"use client";

import Image from "next/image";
import { Link } from "~/i18n/navigation";
import { FaDiscord, FaXTwitter, FaRedditAlien } from "react-icons/fa6";
import PreFooterCTA from "~/components/layout/PreFooterCTA";
import { useTranslations } from "next-intl";
import { LanguageSwitcher } from "~/components/layout/LanguageSwitcher";

const Footer = () => {
  const t = useTranslations("Footer");

  return (
    <>
      <PreFooterCTA />
      <footer className="from-pory-blue-800 via-pory-blue-900 to-pory-blue-950 bg-linear-to-b text-white">
      {/* Main Footer Content */}
      <div className="mx-auto w-full max-w-[1440px] p-6">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-4">
          {/* Brand Section */}
          <div className="col-span-1 md:col-span-2">
            <Image
              src="/porypro-logostack-clearspace.svg"
              alt="PoryPro Logo"
              width={200}
              height={100}
              className="mb-2 -ml-6"
            />
            <p className="text-pory-blue-200 mb-6 max-w-md text-sm leading-relaxed">
              {t("brandDescription")}
            </p>
            {/* Social Icons */}
            <div className="flex items-center gap-4">
              <Link
                href="https://discord.com/invite/a5Te3ptPdQ"
                className="bg-pory-blue-700/50 hover:bg-pory-pink-500 flex h-10 w-10 items-center justify-center rounded-full transition-colors duration-300"
                aria-label="Discord"
              >
                <FaDiscord size={20} />
              </Link>
              <a
                href="https://x.com/poryproweb"
                className="bg-pory-blue-700/50 hover:bg-pory-pink-500 flex h-10 w-10 items-center justify-center rounded-full transition-colors duration-300"
                aria-label="Twitter"
              >
                <FaXTwitter size={18} />
              </a>
              <a
                href="https://www.reddit.com/r/porypro/"
                className="bg-pory-blue-700/50 hover:bg-pory-pink-500 flex h-10 w-10 items-center justify-center rounded-full transition-colors duration-300"
                aria-label="Reddit"
              >
                <FaRedditAlien size={20} />
              </a>
              <div className="ml-2">
                <LanguageSwitcher variant="footer" />
              </div>
            </div>
          </div>

          {/* Pages Section */}
          <div>
            <h3 className="mb-4 text-sm font-bold tracking-wider uppercase">
              {t("explore")}
            </h3>
            <ul className="text-pory-blue-200 space-y-3 text-sm">
              <li>
                <Link
                  href="/pokemon"
                  className="hover:text-pory-pink-400 transition-colors"
                >
                  {t("pokemonLink")}
                </Link>
              </li>
              <li>
                <Link
                  href="/nests"
                  className="hover:text-pory-pink-400 transition-colors"
                >
                  {t("nestsLink")}
                </Link>
              </li>
              <li>
                <Link
                  href="/invasion"
                  className="hover:text-pory-pink-400 transition-colors"
                >
                  {t("invasionLink")}
                </Link>
              </li>
              <li>
                <Link
                  href="/quests"
                  className="hover:text-pory-pink-400 transition-colors"
                >
                  {t("questsLink")}
                </Link>
              </li>
              <li>
                <Link
                  href="/raids"
                  className="hover:text-pory-pink-400 transition-colors"
                >
                  {t("raidsLink")}
                </Link>
              </li>
              <li>
                <Link
                  href="/events"
                  className="hover:text-pory-pink-400 transition-colors"
                >
                  {t("eventsLink")}
                </Link>
              </li>
              <li>
                <Link
                  href="/pokemon-go-shiny-bug-2026"
                  className="hover:text-pory-pink-400 transition-colors"
                >
                  {t("shinyBugLink")}
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal Section */}
          <div>
            <h3 className="mb-4 text-sm font-bold tracking-wider uppercase">
              {t("legal")}
            </h3>
            <ul className="text-pory-blue-200 space-y-3 text-sm">
              <li>
                <Link
                  href="/privacy"
                  className="hover:text-pory-pink-400 transition-colors"
                >
                  {t("privacy")}
                </Link>
              </li>
              <li>
                <Link
                  href="/terms"
                  className="hover:text-pory-pink-400 transition-colors"
                >
                  {t("terms")}
                </Link>
              </li>
              <li>
                <Link
                  href="/cookies"
                  className="hover:text-pory-pink-400 transition-colors"
                >
                  {t("cookies")}
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-pory-blue-700/50 border-t">
        <div className="mx-auto flex w-full max-w-[1440px] flex-col items-center justify-between gap-4 px-6 py-6 md:flex-row">
          <p className="text-pory-blue-300 text-sm">
            © {new Date().getFullYear()} Pory.Pro —{" "}
            <Link
              className="site-author hover:text-pory-pink-400 transition-colors"
              href="https://debauc.us"
              rel="noopener noreferrer nofollow"
              target="_blank"
            >
              {t("copyright")}
            </Link>
          </p>
          <p className="text-pory-blue-400 max-w-2xl text-center text-[10px] leading-relaxed md:text-right">
            {t("disclaimer")}
          </p>
        </div>
      </div>
      </footer>
    </>
  );
};

export default Footer;
